import { createSlice } from '@reduxjs/toolkit';
import { getStlifeList } from '../thunks/studentLifeThunk';

const initialState = {
  list: [],
  total: 0,
  loading: false,
  error: null,
};

const studentLife = createSlice({
  name: 'stlife',
  initialState,
  reducers: {
    setData(state, action) {
      state.list = action.payload.data;
      state.total = action.payload.total;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(getStlifeList.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getStlifeList.fulfilled, (state, action) => {
        state.list = action.payload.data;
        state.total = action.payload.total;
        state.loading = false;
      })
      .addCase(getStlifeList.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { setData } = studentLife.actions;
export default studentLife.reducer;